'use client'

import textTitleM from '@fukku/styles/texts/textTitleM.module.css'
import type { ReactNode } from 'react'
import { useResponsive } from 'responsive/hooks/useResponsive/useResponsive'
import { CapsuleBannerType } from 'services/graphql/contentStack/homes/query.type'
import { cx } from 'utils/cx'
import type { Cta } from '../../../../Home.type'
import { CapsuleBannerCtas } from '../CapsuleBannerCtas/CapsuleBannerCtas'
import styles from './CapsuleBannerText.module.css'

interface CapsuleBannerTextProps {
	readonly titleText: string
	readonly type: CapsuleBannerType
	readonly inverse: boolean
	readonly tag?: string
	readonly ctas: Cta[]
}

export function CapsuleBannerText({
	titleText,
	type,
	inverse,
	tag,
	ctas,
}: CapsuleBannerTextProps): ReactNode {
	const { isSmall } = useResponsive()

	const isTitleContainerColumn = isSmall && ctas && ctas.length > 1
	const titleAndTag = (
		<>
			{type === CapsuleBannerType.Collections && tag && (
				<span className={cx(styles.tag, textTitleM.className)}>{tag}</span>
			)}
			<h2 className={cx(styles.title, textTitleM.className)}>{titleText}</h2>
		</>
	)

	return (
		<div className={styles.textWrapper}>
			{isTitleContainerColumn ? (
				<div className={styles.titleContainerColumn}>{titleAndTag}</div>
			) : (
				titleAndTag
			)}
			{ctas?.length > 1 && <CapsuleBannerCtas ctas={ctas} inverse={inverse} />}
		</div>
	)
}
